var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }